export enum SystemNotificationType {
  highSeverityPrimary = 'high-severity-primary',
  highSeverityAlternate = 'high-severity-alt',
  highSeverityAcknowledged = 'high-severity-acknowledged',
  moderateSeverityPrimary = 'moderate-severity-primary',
  moderateSeverityAlternate = 'moderate-severity-alt',
  moderateSeverityAcknowledged = 'moderate-severity-acknowledged',
  lowSeverityPrimary = 'low-severity-primary',
  lowSeverityAlternate = 'low-severity-alt',
  lowSeverityAcknowledged = 'low-severity-acknowledged',
  success = 'success',
  successAcknowledged = 'success-acknowledged',
  infoGeneral = 'info-general',
  infoAcknowledged = 'info-acknowledged',
  infoHighlightedOption1 = 'info-highlighted-option-1',
  infoHighlightedOption2 = 'info-highlighted-option-2',
  infoHighlightedOption3 = 'info-highlighted-option-3'
}
